"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 68px;
  height: 68px;
  border: 2px solid ${colors_1.WHITE};
  background-color: ${colors_1.LIGHT_GREY};
  border-radius: 50%;
  &:hover {
    cursor: pointer;
  }
`;
//# sourceMappingURL=FloatingActionButton.styles.js.map